// note(juan): this is a false-positive due to an ESlint error https://stackoverflow.com/questions/63961803/eslint-says-all-enums-in-typescript-app-are-already-declared-in-the-upper-scope
 
export enum dailyRoutineStepId {
  overview,
  submitActivity,
}

export const DAILY_ROUTINE_STEPPER_TITLE_IDS: Record<dailyRoutineStepId, string> = {
  [dailyRoutineStepId.overview]: 'overview',
  [dailyRoutineStepId.submitActivity]: 'submitActivity',
};
